<template>
  <div class="testimonials-wrapper">
    <div class="controls prev">
      <a @click="prev">
        <svg class="icon icon-chevron-thin-left">
          <path d="M13.891 17.418c0.268 0.272 0.268 0.709 0 0.979s-0.701 0.271-0.969 0l-7.83-7.908c-0.268-0.27-0.268-0.707 0-0.979l7.83-7.908c0.268-0.27 0.701-0.27 0.969 0s0.268 0.709 0 0.979l-7.141 7.419 7.141 7.418z" fill="#FFFFFF"></path>
        </svg>
      </a>
    </div>

    <div class="slide-wrapper">

      <template v-for="(testimonial, key) in testimonialsParsed">
        <transition :name="direction">
          <div :class="(testimonial.name !== '')?'testimonial with-author':'testimonial'" v-if="key == current">
            "{{testimonial.text}}"
            <span class="author" v-if="testimonial.name !== ''">
              {{testimonial.name}} ({{testimonial.location}})
            </span>
          </div>
        </transition>
      </template>

    </div>

    <div class="controls next">
      <a @click="next">
        <svg class="icon icon-chevron-thin-right">
          <path d="M13.25 10l-7.141-7.42c-0.268-0.27-0.268-0.707 0-0.979 0.268-0.27 0.701-0.27 0.969 0l7.83 7.908c0.268 0.271 0.268 0.709 0 0.979l-7.83 7.908c-0.268 0.271-0.701 0.27-0.969 0s-0.268-0.707 0-0.979l7.141-7.417z" fill="#FFFFFF"></path>
        </svg>
      </a>
    </div>
  </div>
</template>

<style scoped>
  .next-enter-active,
  .next-leave-active {
    transition: left .5s;
  }
  .next-enter {
    left: -200%;
  }
  .next-enter-to {
    left: 50%;
  }
  .next-leave-to {
    left: 200%;
  }
  .prev-enter-active,
  .prev-leave-active {
    transition: left .5s;
  }
  .prev-enter {
    left: 200%;
  }
  .prev-enter-to {
    left: 50%;
  }
  .prev-leave-to {
    left: -200%;
  }
</style>

<script>
  export default {
    name: 'Testimonials',
    props: ['testimonials-json'],
    data () {
      return {
        testimonialsParsed : JSON.parse(this.testimonialsJson),
        testimonialsCount  : Object.keys(JSON.parse(this.testimonialsJson)).length,
        current : 0,
        direction : 'next'
      }
    },
    methods: {
      prev: function() {
        (this.current > 0)?this.current--:this.current=this.testimonialsCount-1;
        this.direction = "prev";
      },
      next: function() {
        (this.current < this.testimonialsCount-1)?this.current++:this.current=0;
        this.direction = "next";
      }
    }
  }
</script>
